import axios from "axios";

const getServerUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === "au.wowzerbackupandrestore.com") {
    return "https://au-api.wowzerbackupandrestore.com";
  }
  if (hostname === "austg.wowzerbackupandrestore.com") {
    return "https://austg-api.wowzerbackupandrestore.com";
  }
  if (hostname === "staging.wowbackupandrestore.com") {
    return "https://staging-api.wowbackupandrestore.com";
  }
  if (hostname === "app.wowbackupandrestore.com") {
    return "https://api.wowbackupandrestore.com";
  }
  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return process.env.REACT_APP_API_URL || "http://localhost:8000";
  }
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Legacy default for unlisted hostnames (e.g. internal AU preview hosts).
  return "https://austg-api.wowzerbackupandrestore.com";
};

export const SERVER_URL = getServerUrl();

axios.defaults.baseURL = SERVER_URL;

// Add response interceptor to handle 403 Forbidden responses
axios.interceptors.response.use(
  (response) => {
    // Pass through successful responses
    return response;
  },
  (error) => {
    // Check if the error response status is 403 (Forbidden)
    if (error.response && error.response.status === 403) {
      // Immediately refresh the page
      window.location.reload();
    }
    // Reject the promise so other error handlers can still catch it if needed
    return Promise.reject(error);
  }
);

export default axios;
